export default __webpack_public_path__ + "static/media/guide05.f3fad277.png";